const React = require("react");

const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text

const resizeSuperscript = (text, char = "®") => {
  if (!text?.includes(char)) return text;
  return text
    .split(char)
    .flatMap((part, idx, arr) => [
      part,
      idx < arr.length - 1 && React.createElement("sup", { key: `sup-${idx}` }, char),
    ]);
};

const formatDateShort = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const DEFAULT_SORT_ORDER = Number.MAX_SAFE_INTEGER;

const createItemSortOrder =
  (orderMap = {}) =>
  (slug) =>
    Object.prototype.hasOwnProperty.call(orderMap, slug) ? orderMap[slug] : DEFAULT_SORT_ORDER;

module.exports = {
  slugify,
  resizeSuperscript,
  formatDateShort,
  createItemSortOrder,
};
